import { Spin } from 'antd';
import { useAtomValue } from 'jotai';
import { Navigate, useLocation } from 'react-router-dom';

import { userAtom } from '../utils/store';
import { useValidateUser } from './useValidateUser';
import { useInactivity } from './useInactivity';
import { usePermissions } from './usePermissions';

interface ComponentProp {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ComponentProp) => {
  const user = useAtomValue(userAtom);
  const location = useLocation();
  useInactivity(!!user);

  const { isLoading: isValidating } = useValidateUser();
  const { canAccess, isLoading: isPermissionsLoading } = usePermissions();

  if (isValidating || isPermissionsLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!canAccess(location.pathname)) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '60vh',
          gap: 12,
          color: '#666',
        }}
      >
        <h2 style={{ margin: 0 }}>Access Denied</h2>
        <p style={{ margin: 0 }}>You don't have permission to view this page.</p>
        <p style={{ margin: 0, fontSize: 13 }}>
          Contact your administrator to request access.
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
